import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { LoadingService } from 'src/app/services/loading.service';
import { ItemCategoryService, ItemForAppStoreDto, ItemsCategoryOutputDto, ItemService, StoreResponseDto } from 'src/generated_client';

@Component({
  selector: 'app-articles-menu',
  templateUrl: './articles-menu.component.html',
  styleUrls: ['./articles-menu.component.scss'],
})
export class ArticlesMenuComponent implements OnInit {

  allCategories: ItemsCategoryOutputDto[] = [];
  allItems: ItemForAppStoreDto[] = [];
  storeResponse: StoreResponseDto = {};
  categorySelected: number;

  constructor(
    public itemService: ItemService,
    public authService: AuthService,
    private categoryService: ItemCategoryService,
    private router: Router,
    public loading: LoadingService
  ) { }


  async ngOnInit() {

    this.storeResponse = this.authService.currentUserStore();

    await this.categoryService.apiItemCategoryGetAllGet(this.storeResponse.cdStore)
      .toPromise()
      .then(x => this.allCategories = x)
      .catch(error => console.log(error));

    if (this.allCategories.length > 0)
      await this.showProduct(this.allCategories[0].cdItemsCategory);
  }

  async showProduct(id: number) {

    await this.loading.presentLoading();

    this.categorySelected = id;

    await this.itemService.apiItemGetAllByCategoryGet(this.storeResponse.cdStore, id)
      .toPromise()
      .then(x => this.allItems = x)
      .catch(error => console.log(error));

    await this.loading.dismiss();
  }

  async changeStatus(id: number, status: boolean) {

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    await this.itemService.apiItemItemStatePut(id, status)
      .toPromise()
      .catch(error => console.log(error));
  }
}
